import React from "react";
import PDFPage from "../../../themed/pdf/pdfPage";
import PdfPhotoPage from "../../../themed/pdf/pdfPhotoPage";

import { PDFImageProps, Project } from "../../../../utils/models";
import { getChunkedData, getPageDetails } from "../../../../utils/utilities";

interface PhotoGraphicRecordProps {
  accessStairway: PDFImageProps[];
  generalView: PDFImageProps[];
  perimeterGeneralView: PDFImageProps[];
  personnelFrictionTest: PDFImageProps[];
  personnelGridlines: PDFImageProps[];
  frictionTestMachine: PDFImageProps[];
  crashEquipmentBox: PDFImageProps[];
  powerPressureVessel: PDFImageProps[];
  helideckSurfaceWater: PDFImageProps[];
  gridlineMarkings: PDFImageProps[];
  personnelWetCondition: PDFImageProps[];
  projectDetails: Project;
}

const HelideckPhotographicRecordPDF = (props: PhotoGraphicRecordProps) => {
  const mapAllImages = (): PDFImageProps[] => {
    const images: PDFImageProps[] = [];
    for (const key in props) images.push(...(props as any)[key]);

    return images;
  };
  const chunkedImages = getChunkedData(mapAllImages(), 4);

  return (
    <React.Fragment>
      {chunkedImages.map((images: PDFImageProps[], index: number) => (
        <PDFPage
          key={index.toString()}
          enableTitlePage={index === 0}
          projectDetails={props.projectDetails}
          pageDetails={getPageDetails("Photographic Record", "General View")}
        >
          <PdfPhotoPage photos={images} />
        </PDFPage>
      ))}
    </React.Fragment>
  );
};

export default HelideckPhotographicRecordPDF;
